import styled from 'styled-components';

export const BodyContent = styled.div`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #2e2e38;
  overflow-y: auto;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
`;

export const ParagraphStyle = styled.span`
  color: #2e2e38;
  font-size: 14px;
  line-height: 22px;
`;
